import React from 'react';
import { FiExternalLink, FiAward, FiDownload } from 'react-icons/fi';

const certificationsData = [
  {
    id: 1,
    name: 'DevOps Foundations: Continuous Delivery/Continuous Integration',
    issuer: 'LinkedIn Learning',
    description: 'Comprehensive course covering DevOps methodologies, CI/CD pipelines, and automation practices',
    url: 'https://lnkd.in/eHkS6b-2',
    image: '/CertificateOfCompletion_DevOps Foundations Continuous DeliveryContinuous Integration.pdf',
    pdfName: 'CertificateOfCompletion_DevOps Foundations Continuous DeliveryContinuous Integration.pdf',
    date: '2025',
    skills: ['DevOps', 'CI/CD', 'Continuous Integration', 'Continuous Delivery', 'Automation']
  },
  {
    id: 2,
    name: 'Prompt Engineering: How to Talk to the AIs',
    issuer: 'LinkedIn Learning',
    description: 'Mastering the art of communicating with Large Language Models and Generative AI systems',
    url: 'https://www.linkedin.com/learning/certificates/2bc21890c12a146831a2208c6995b8c283602ef8729689e08c4a36a449d261e1?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BLqVgsWeSTgagXlKurLl4xw%3D%3D',
    image: '/CertificateOfCompletion_Prompt Engineering How to Talk to the AIs.pdf',
    pdfName: 'CertificateOfCompletion_Prompt Engineering How to Talk to the AIs.pdf',
    date: '2025',
    skills: ['Generative AI', 'Large Language Models', 'Prompt Engineering', 'AI Communication', 'LLM']
  },
  {
    id: 3,
    name: 'Agile Project Management with Jira Cloud: 2 Lean and Agile Processes',
    issuer: 'LinkedIn Learning',
    description: 'Advanced Agile methodologies and project management using Jira Cloud platform',
    url: 'https://www.linkedin.com/learning/certificates/17bc331c762c2841c3849a4c5103870e4a959cc61cd116c8a80d7791c9050138?trk=share_certificate%20&lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BLqVgsWeSTgagXlKurLl4xw%3D%3D#jira%20',
    image: '/CertificateOfCompletion_Agile Project Management with Jira Cloud 2 Lean and Agile Processes.pdf',
    pdfName: 'CertificateOfCompletion_Agile Project Management with Jira Cloud 2 Lean and Agile Processes.pdf',
    date: '2025',
    skills: ['Agile Project Management', 'Jira Cloud', 'Lean Processes', 'Agile Methodologies', 'Project Management']
  },
  {
    id: 4,
    name: 'AI for Software Testers: Apply AI Tools and Techniques to the Software Testing Life Cycle',
    issuer: 'LinkedIn Learning',
    description: 'Software testing with AI tools and techniques to improve testing efficiency and accuracy in the software testing life cycle',
    url: 'https://www.linkedin.com/learning/certificates/d886aa09dddf95a8576d8b81f740451ae47b68300dbb0aec562dbe40cc0fe9f9?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BL%2BVmTUNiReGFKMJ9p0MRaA%3D%3D',
    image: '/CertificateOfCompletion_AI for Software Testers Apply AI Tools and Techniques to the Software Testing Life Cycle.pdf',
    pdfName: 'CertificateOfCompletion_AI for Software Testers Apply AI Tools and Techniques to the Software Testing Life Cycle.pdf',
    date: '2025',
    skills: ['AI', 'Software Testing', 'Testing', 'Testing Life Cycle', 'AI Testing']
  },

  {
    id: 5,
    name: 'ACCELQ Automation Engineer',
    issuer: 'ACCELQ ',
    description: 'The Certified ACCELQ Automation Engineer certification exam is to test your skills and real-world know-how of the ACCELQ platform and core principles of Test Automation',
    url: 'https://certificate.accelq.com/verify/b1230805689',
    image: '/ACCELQ Automation Engineer.pdf',
    pdfName: 'ACCELQ Automation Engineer.pdf',
    date: '2025',
    skills: ['Test Automation', 'ACCELQ Platform', 'Automation Frameworks', 'Test Design', 'Continuous Integration (CI/CD)', 'Functional Testing', 'Regression Testing', 'Agile Testing']
  },

  {
    id: 6,
    name: 'International Software Testing Qualifications Board (ISTQB) 4.0+ Foundation Cert Prep',
    issuer: 'LinkedIn Learning',
    description: 'ISTQB 4.0+ Foundation Certificate Prep course from LinkedIn Learning, covering core software testing concepts, SDLC, static testing techniques, and industry best practices for quality assurance.',
    url: 'https://www.linkedin.com/learning/certificates/fa4ac243d1b2bd215754425c711b823dfe27263bf494f311cf1a1767ac97a437?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base%3BfcSeobsOQSGUkI5M5gTnIQ%3D%3D',
    image: '/CertificateOfCompletion_International Software Testing Qualifications Board ISTQB 4.0 Foundation Cert Prep.pdf',
    pdfName: 'CertificateOfCompletion_International Software Testing Qualifications Board ISTQB 4.0 Foundation Cert Prep.pdf',
    date: '2025',
    skills: ['Software Development', 'SDLC', 'Static Testing']
  },

  {
    id: 7,
    name: 'Cucumber with JavaScript',
    issuer: 'applitools',
    description: 'Cucumber with JavaScript from Applitools, focusing on Behavior-Driven Development (BDD) using Gherkin syntax to write clear, collaborative, and automated test scenarios.',
    url: 'https://testautomationu.applitools.com/certificate/?id=5a32fbf7',
    image: '/Cucumber with JavaScript.pdf',
    pdfName: 'Cucumber with JavaScript.pdf',
    date: '2025',
    skills: ['Behavior-Driven Development (BDD)', 'Gherkin']
  },
  
];

const Certifications = ({ hideTitle = false }) => {
  const handleCertificateClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleViewCertificate = (image, certificateName) => {
    if (image) {
      // Create a temporary link element to trigger download
      const link = document.createElement('a');
      link.href = image;
      link.download = certificateName;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <section id="certifications" className="section-padding bg-white dark:bg-dark-100 transition-colors duration-300">
      <div className="container-custom">
        {!hideTitle && (
        <h2 className="text-3xl font-bold mb-8 text-secondary-800 dark:text-white text-center">
          Certifications & Achievements
        </h2>
        )}
        <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-6">
          {certificationsData.map((cert) => (
            <div
              key={cert.id}
              className="bg-white/80 dark:bg-dark-200/80 border border-primary-200 dark:border-primary-600 rounded-2xl shadow-lg p-6 backdrop-blur-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-start gap-3 flex-1">
                  <div className="p-2 bg-primary-100 dark:bg-primary-700 rounded-lg flex-shrink-0 mt-1">
                    <FiAward className="w-5 h-5 text-primary-600 dark:text-primary-300" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="text-lg font-semibold text-secondary-800 dark:text-white leading-tight">
                      {cert.name}
                    </h3>
                    <p className="text-sm text-primary-600 dark:text-primary-400 font-medium mt-1">
                      {cert.issuer}
                    </p>
                  </div>
                </div>
                <span className="text-xs text-secondary-500 dark:text-secondary-400 bg-secondary-100 dark:bg-secondary-800 px-2 py-1 rounded-full flex-shrink-0 ml-2">
                  {cert.date}
                </span>
              </div>
              
              <p className="text-secondary-600 dark:text-secondary-300 text-sm mb-4 leading-relaxed flex-1">
                {cert.description}
              </p>

              {/* Skills Section */}
              <div className="mb-4">
                <h4 className="text-sm font-semibold text-secondary-700 dark:text-secondary-300 mb-2">
                  Skills Covered:
                </h4>
                <div className="flex flex-wrap gap-2">
                  {cert.skills.map((skill, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 text-xs bg-primary-50 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 rounded-md border border-primary-200 dark:border-primary-700"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
              
              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-2 mt-auto">
                <button
                  onClick={() => handleCertificateClick(cert.url)}
                  className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white text-sm font-medium rounded-lg transition-colors duration-200"
                >
                  <FiExternalLink className="w-4 h-4" />
                  <span className="hidden sm:inline">View Certificate</span>
                  <span className="sm:hidden">View</span>
                </button>
                <button
                  onClick={() => handleViewCertificate(cert.image, cert.pdfName)}
                  className="flex items-center justify-center gap-2 px-4 py-2 bg-secondary-100 hover:bg-secondary-200 dark:bg-secondary-700 dark:hover:bg-secondary-600 text-secondary-700 dark:text-secondary-200 text-sm font-medium rounded-lg transition-colors duration-200 min-w-[120px]"
                >
                  <FiDownload className="w-4 h-4" />
                  <span className="hidden sm:inline">Download</span>
                  <span className="sm:hidden">PDF</span>
                </button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-8 text-center">
          <p className="text-secondary-600 dark:text-secondary-400 text-sm">
            Click on "View Certificate" to verify the certificate online, or "Download" to view the PDF version.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
